export const tabs = [
  {
    id: 1,
    label: 'NAO details',
    path: '/details'
  },
  {
    id: 2,
    label: 'Mobile App',
    path: '/mobile'
  },
  {
    id: 3,
    label: 'User Management',
    path: '/user-management'
  },
  {
    id: 4,
    label: 'Localization',
    path: '/localization'
  },
  {
    id: 5,
    label: 'ORB settings',
    path: '/orb-settings'
  },
  {
    id: 6,
    label: 'Logs',
    path: '/logs'
  }
]
